import { FC, useEffect, useContext, useState } from "react";
import { format } from "date-fns";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { AuthContext } from "src/context/authContext";
import FooterText from "src/components/footerText";

import { TerritoriesSearchProps } from "src/components/manufacturer/statistics/types";
import { CaseListingType, StatisticsApiResponse, statisticsErrorAndData } from "./types";
import CaseVolumeHorizontal from "src/components/caseVolumeHorizontal";
import PieChartTerritories from "src/components/pieChartTerritories";
import CaseDetail from "src/components/manufacturer/caseDetail";
import TerritoriesFilter from "src/components/territoriesFilter";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";




const Territories: FC = (): JSX.Element => {
  const [searchParams, updateSearchParams] = useSearchParams();
  const { destroySession } = useContext(AuthContext)
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const { id } = useParams();


  const [queryParams, changeQueryParams] = useState<TerritoriesSearchProps>({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter: searchParams.get("filter") || "",
    // time: searchParams.get("time") || "",
    type: searchParams.get('type') || "territories",
    role: searchParams.get('role') || "rep_user",
    id: Number(searchParams.get('id')) ||  Number(id) || 0,
    case_id:''
  });



  const { data: statisticsData, error: errorAndData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useEffect(() => {
    if (errorAndData) {
      if (typeof errorAndData === "string")
        showToast([errorAndData], ToastTypes.ERROR);
      else {
        const { error, code } = errorAndData as unknown as statisticsErrorAndData;
        hideLoader();
        showToast([error || `Can't fetch statistics right now. Please try again in a while.`], ToastTypes.ERROR);
  
        if (code === 401) {
          destroySession();
          navigate(`/users/sign_in`);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorAndData]);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);

  const updateQueryParamsAndCallAPI = (
    updatedQueries: TerritoriesSearchProps,
    isReset: boolean = false
  ): void => {
    // const updatedQueryObj: TerritoriesSearchProps = {
    //   ...updatedQueries,
    //   ...(updatedQueries.case_id ? { role: "", type: "" } : { role: updatedQueries.role, type: updatedQueries.type })
    // }

    if (isReset) { 
      updateSearchParams({});
      changeQueryParams({
        start_date:
          searchParams.get("start_date") ||
          format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
        end_date:
          searchParams.get("end_date") ||
          format(new Date().setDate(new Date().getDate() + 1 ), "yyyy-MM-dd"),
        period: "",
        filter: "",
        // time: "",
        type: searchParams.get('type') || "",
        role: searchParams.get('role') || "",
        id: Number(searchParams.get('id')),
        case_id: ''
      });
    } else {
      changeQueryParams(updatedQueries);
    }
    // console.log("Updated Queries ....",updatedQueries)
    setLoader();
    getStatsData({}, {}, updatedQueries);
  };


  return (
    <div className="container-fluid auth-page mb-4 overflow-x-hidden">
      {statisticsData && <AuthMaunfacturerSubHeader user={statisticsData.data?.sub_header?.user || undefined} territory={statisticsData.data?.sub_header?.territory || undefined}/>}

      {statisticsData && (
        <TerritoriesFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />
      )}
      <div className="mt-3">
        {statisticsData && <CaseVolumeHorizontal StatisticsObjectType={statisticsData.data} />}
      </div>
      <div className="mb-3">
        {statisticsData && <PieChartTerritories StatisticsObjectType={statisticsData.data} />}
      </div>

     
      <div className="row">
        <div className="mt-3">
          {statisticsData && <CaseDetail baseUrl="/statistics" searchParams={queryParams} CaseDetailListType={statisticsData.data.case_listing as unknown as CaseListingType[]} />}
        </div>
      </div>
      <FooterText footerType="black" />
    </div>

  );
};

export default Territories;
